import { ReactNode } from 'react'
import clsx from 'clsx'

export const NotificationDot = ({ display, children }: { display: boolean; children: ReactNode }) => {
  return (
    <div className={'relative'}>
      {children}
      <div
        className={clsx('absolute top-0 right-0 bg-red-400 rounded-full w-[6px] h-[6px]', {
          hidden: !display,
          block: display,
        })}
      />
    </div>
  )
}
